import * as d3 from 'd3'

export default {
  methods: {

    draw_Handover() {

      this.canvasOptions = this.canvasForm
      .append('g')
      .attr('transform', `translate(0, 0)`)


      let legends = this.canvasOptions
      .append('g')
      .attr('id', `LEGENDS`)
      .attr('transform', `translate(${40}, 400)`)

      legends
      .append('text')
      .attr('transform', `translate(0, 0)`).attr('font-size', 13).attr('fill', '#000')
      .text(`Legends`)

      let y_ = 10
      this.status.forEach(d=> {
        let overall = legends
        .append('g')
        .attr('id', `LEGEND_${d.code}`)
        .attr('transform', `translate(0, ${y_})`).attr('opacity', 1).attr('cursor', 'pointer')
        .on('mouseover', ()=> {
          if(this.current.status == d.code) return
          d3.select(`#LG_${d.code}`).transition().duration(50).attr('fill', '#bcbcbc')
        })
        .on('mouseout', ()=> {
          if(this.current.status == d.code) return
          d3.select(`#LG_${d.code}`).transition().duration(50).attr('fill', '#757575')
        })
        .on('click', () => {
          if(this.current.status == d.code) return
          d3.select(`#LG_${this.current.status}`).attr('fill', '#757575')

          this.current.status = d.code
          d3.select(`#LG_${d.code}`).attr('fill', '#000')
          this.current.handover = 'OVERALL'

          this.current.page = 1
          this.filteringData()

          d3.select(`#HANDOVER`).remove()
          this.reflash_Handover(this.canvasOptions)

          this.canvasSystems.remove()
          this.draw_SystemList()
        })

        overall
        .append('rect')
        .attr('x', 0).attr('y', 5).attr('rx', 1).attr('ry', 1)
        .attr('width', 10).attr('height', 10).attr('fill', '#fff').attr('stroke', d.color).attr('stroke-width', 1)

        overall
        .append('text')
        .attr('id', `LG_${d.code}`)
        .attr('transform', `translate(14, 14)`).attr('font-size', 10)
        .attr('fill', this.current.status == d.code ? '#000' : '#757575')
        .text(`${d.name} (${d.count})`)

        y_ += 25
      })

      this.reflash_Handover(this.canvasOptions)
      this.draw_Summary()
    },


    reflash_Handover(selection) {
      
      
      let data = this.handover.filter(f=> f.count>0)
      let handover = selection
      .append('g')
      .attr('id', `HANDOVER`)
      .attr('transform', `translate(40, 530)`)
      this.dia_Dropdown(handover, data, {id: 'HANDOVER2', label: 'Handover Group', boxWidth: 200, x: 0, y: 0})
    },


    draw_Summary() {
      this.loadSvg(
        this.canvasOptions, {x: this.innerSVG.summary.x, y: this.innerSVG.summary.y, url: this.Boundary + `Form_Index.svg`}
      ).then(() => {
        d3.selectAll('text').style('font-family', 'roboto')

        this.summary.filter(f=> f.type =='PRO').forEach(d=> {
          let matrix = this.gmx_matrix2(`#${d.id}`)
          d3.select(`#${d.id}`).attr('transform', null).attr('x', matrix.x).attr('y', matrix.y)
        })

        if (this.current.mouseover) {
          let data = this.setData.find(f => f.SYS == this.current.mouseover)
          this.draw_SummaryReflash(data)
        }

        if (this.current.sys) {
          this.canvasOptions.remove()
        }

        d3.select(`#HANDOVER`).moveToFront()
      })
    },


    draw_SummaryReflash(data) {
      // TEXT
      this.summary.filter(f => !f.type).forEach(d => {
        if(d.id == 'SUM-SYS' || d.id == 'SUM-DESC') {
          d3.select(`#${d.id}`).text(data[d.code].length > 45 ? data[d.code].substr(0,45) + '...' : data[d.code])
        }
        else {
          d3.select(`#${d.id}`).attr('text-anchor', 'end')
          .style('fill', data[d.code] == 0 ? '#bcbcbc' : '#333')
          .call(this.event_Link, data, d.code, d.req, d.filter)
          this.gmx_textTween(`#${d.id}`, data[d.code], 300)
        }
      })

      // Progress BAR
      this.summary.filter(f=> f.type).forEach(d=> {

        if(d.type=='PRO') {
          let x = this.innerSVG.summary.pro + Number(data[d.code])
          d3.select(`#${d.id}`).transition().duration(500)
          .attr('x', data[d.code] < 70 ? x+2 : x-2)
          .attr('text-anchor', data[d.code] < 70 ? 'start' : 'end')
          .text(data[d.code]+'%')
        }

        if(d.type=='BAR') {
          d3.select(`#${d.id}`).transition().duration(500)
          .attr('width', data[d.code])
        }

      })
      
    },


    init_Summary() {
      // TEXT
      this.summary.filter(f=> !f.type).forEach(d=> {
        if(d.id == 'SUM-SYS' || d.id == 'SUM-DESC') d3.select(`#${d.id}`).text('')
        else d3.select(`#${d.id}`).text(0)
      })

      // Progress BAR
      this.summary.filter(f=> f.type).forEach(d=> {
        if(d.type=='PRO') d3.select(`#${d.id}`).text('0%')
        if(d.type=='BAR') d3.select(`#${d.id}`).attr('width', 0)
      })
    },

  }
}